/**
 * replaceToHeaderPlaceholder
 * @param content :content ;
 * @returns new content
 */
export const getHeaderPlaceholder = (): string => {
  return /*html*/ `
    <header data-section-id="header">
      <div class="header-footer__wrapper">
        <div class="header-footer__space-between header-footer__container">
          <div class="header-footer__box medium">&#32</div>
          <div class="header-footer__items-center">
            <div class="header-footer__box small">&#32</div>
            <div class="header-footer__box small">&#32</div>
            <div class="header-footer__box small last">&#32</div>
          </div>
        </div>
      </div>
      <div class="header-footer__items-center header-footer__container" >
        <span class="text-light-disabled header-footer__text">
          This is placeholder for your header
        </span>
        <span class="header-footer__tooltip">
          <span class="header-footer__tooltip-content">
            The header on the live store will display according to the header of your theme store. 
            <br> This is just an illustration in Editor GemPages
          </span>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00002 4.27295C6.42801 4.27295 5.9646 4.73636 5.9646 5.30804C5.9646 5.67048 5.67079 5.96429 5.30835 5.96429C4.94591 5.96429 4.6521 5.67048 4.6521 5.30804C4.6521 4.01116 5.70346 2.96045 7.00002 2.96045C8.29673 2.96045 9.34793 4.01165 9.34793 5.30837C9.34793 6.30321 8.72096 7.19006 7.78308 7.52185C7.7073 7.54865 7.65653 7.62036 7.65657 7.70074V8.26846C7.65657 8.6309 7.36276 8.92471 7.00032 8.92471C6.63788 8.92471 6.34407 8.6309 6.34407 8.26846L6.34407 7.70142C6.34388 7.06472 6.74514 6.49671 7.34546 6.28446C7.759 6.1381 8.03543 5.74704 8.03543 5.30837C8.03543 4.73652 7.57186 4.27295 7.00002 4.27295Z" fill="#666666"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0217 2.97833C8.80056 0.757223 5.19944 0.757223 2.97833 2.97833C0.757223 5.19944 0.757223 8.80056 2.97833 11.0217C5.19944 13.2428 8.80056 13.2428 11.0217 11.0217C13.2428 8.80056 13.2428 5.19944 11.0217 2.97833ZM2.05025 2.05025C4.78392 -0.683418 9.21608 -0.683418 11.9497 2.05025C14.6834 4.78392 14.6834 9.21608 11.9497 11.9497C9.21608 14.6834 4.78392 14.6834 2.05025 11.9497C-0.683418 9.21608 -0.683418 4.78392 2.05025 2.05025Z" fill="#666666"/>
            <path d="M7.84572 10.172C7.84572 10.6391 7.46703 11.0178 6.99989 11.0178C6.53275 11.0178 6.15405 10.6391 6.15405 10.172C6.15405 9.70486 6.53275 9.32617 6.99989 9.32617C7.46703 9.32617 7.84572 9.70486 7.84572 10.172Z" fill="#666666"/>
          </svg>
        </span>
      </div>
    </header>
  `;
};

/**
 * replaceToFooterPlaceholder
 * @param content :content ;
 * @returns new content
 */
export const getFooterPlaceholder = (): string => {
  return /*html*/ `
    <footer data-section-id="footer">
      <div class="header-footer__items-center header-footer__container footer">
        <span class="text-light-disabled header-footer__text">
          This is placeholder for your footer
        </span>
        <span class="header-footer__tooltip">
          <span class="header-footer__tooltip-content">
            The footer on the live store will display according to the footer of your theme store.
            <br> This is just an illustration in Editor GemPages
          </span>
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.00002 4.27295C6.42801 4.27295 5.9646 4.73636 5.9646 5.30804C5.9646 5.67048 5.67079 5.96429 5.30835 5.96429C4.94591 5.96429 4.6521 5.67048 4.6521 5.30804C4.6521 4.01116 5.70346 2.96045 7.00002 2.96045C8.29673 2.96045 9.34793 4.01165 9.34793 5.30837C9.34793 6.30321 8.72096 7.19006 7.78308 7.52185C7.7073 7.54865 7.65653 7.62036 7.65657 7.70074V8.26846C7.65657 8.6309 7.36276 8.92471 7.00032 8.92471C6.63788 8.92471 6.34407 8.6309 6.34407 8.26846L6.34407 7.70142C6.34388 7.06472 6.74514 6.49671 7.34546 6.28446C7.759 6.1381 8.03543 5.74704 8.03543 5.30837C8.03543 4.73652 7.57186 4.27295 7.00002 4.27295Z" fill="#666666"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0217 2.97833C8.80056 0.757223 5.19944 0.757223 2.97833 2.97833C0.757223 5.19944 0.757223 8.80056 2.97833 11.0217C5.19944 13.2428 8.80056 13.2428 11.0217 11.0217C13.2428 8.80056 13.2428 5.19944 11.0217 2.97833ZM2.05025 2.05025C4.78392 -0.683418 9.21608 -0.683418 11.9497 2.05025C14.6834 4.78392 14.6834 9.21608 11.9497 11.9497C9.21608 14.6834 4.78392 14.6834 2.05025 11.9497C-0.683418 9.21608 -0.683418 4.78392 2.05025 2.05025Z" fill="#666666"/>
            <path d="M7.84572 10.172C7.84572 10.6391 7.46703 11.0178 6.99989 11.0178C6.53275 11.0178 6.15405 10.6391 6.15405 10.172C6.15405 9.70486 6.53275 9.32617 6.99989 9.32617C7.46703 9.32617 7.84572 9.70486 7.84572 10.172Z" fill="#666666"/>
          </svg>
        </span>
      </div>
      <div class="header-footer__wrapper">
        <div class="header-footer__space-between header-footer__container">
          <div class="header-footer__box big">&#32</div>
          <div >
            <div class="header-footer__items-center">
              <div class="header-footer__box small">&#32</div>
              <div class="header-footer__box small">&#32</div>
              <div class="header-footer__box small last">&#32</div>
            </div>
            <div class="header-footer__items-center mt-3">
              <div class="header-footer__box small">&#32</div>
              <div class="header-footer__box small">&#32</div>
              <div class="header-footer__box small last">&#32</div>
            </div>
          </div>
        </div>
      </div>
  
    
    </footer>
  `;
};

/**
 * show Header & Footer placeholder on gryffBody
 * @param $gryffBody: gryffBody
 */
export const showHeaderFooterPlaceholderOnGryffBody = ($gryffBody: JQuery) => {
  $gryffBody.find("[data-section-id='header'], [data-section-id='footer']").remove();

  const $pageContainer = $gryffBody.find('#PageContainer');
  $pageContainer.prepend(getHeaderPlaceholder());
  $pageContainer.append(getFooterPlaceholder());
};
